import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import type { getValueTypesForFieldAssetIdsWithPropertyId } from 'App/data-export/store/selectors/_utils/getValueTypesForFieldAssetIdsWithPropertyId'
import type { TArrayElement } from 'App/data-export/types/types'
import { Checkbox } from 'components/Checkbox/Checkbox'
import { groupBy } from 'lodash'
import React from 'react'
import { alphabeticalSort } from 'utils/alphabeticalSort'

export const ValueTypesSection = (props: {
  allowGroupToggle: boolean
  allowSectionToggle: boolean
  sectionLabel: string
  selectedValueTypes: TDataExportStoreState['formState']['valueTypes']
  toggleValueTypes: (event: React.ChangeEvent<HTMLInputElement>) => void
  valueTypesForSection: ReturnType<typeof getValueTypesForFieldAssetIdsWithPropertyId>
  valueTypesGroupByKey: keyof TArrayElement<ReturnType<typeof getValueTypesForFieldAssetIdsWithPropertyId>>
  valueTypesGroupByLabel: keyof TArrayElement<ReturnType<typeof getValueTypesForFieldAssetIdsWithPropertyId>>
  valueTypesGroupBySort: keyof TArrayElement<ReturnType<typeof getValueTypesForFieldAssetIdsWithPropertyId>>
}) => {
  const {
    allowGroupToggle,
    sectionLabel,
    selectedValueTypes,
    toggleValueTypes,
    valueTypesForSection,
    valueTypesGroupByKey,
    valueTypesGroupByLabel,
    valueTypesGroupBySort,
  } = props

  const entryValuesGrouped = Object.values(
    groupBy(valueTypesForSection, (x) => x[valueTypesGroupByKey]),
  ).sort((a, b) => alphabeticalSort(String(a[0][valueTypesGroupBySort]), String(b[0][valueTypesGroupBySort])))

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {props.allowSectionToggle ? (
        <Checkbox
          size="md"
          label={<h3 css={{ margin: 0, fontSize: 17, fontWeight: 'normal' }}>{sectionLabel}</h3>}
          value={valueTypesForSection.map((x) => x.valueType)}
          checked={valueTypesForSection.every((x) => selectedValueTypes.includes(x.valueType))}
          onChange={toggleValueTypes}
        />
      ) : (
        <h3 css={{ margin: 0, fontSize: 17, fontWeight: 'normal' }}>{sectionLabel}</h3>
      )}
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          paddingLeft: 24,
        }}
      >
        {entryValuesGrouped.map((valueTypesForGroup) => {
          const key = valueTypesForGroup[0][valueTypesGroupByKey]
          const label = valueTypesForGroup[0][valueTypesGroupByLabel]
          const entryValuesGroupedByValueType = Object.values(groupBy(valueTypesForGroup, (x) => x.valueType))

          return (
            <div key={key} css={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {allowGroupToggle ? (
                <Checkbox
                  size="md"
                  label={<div css={{ fontWeight: 'bold' }}>{label}</div>}
                  value={entryValuesGroupedByValueType.map((x) => x[0].valueType)}
                  checked={entryValuesGroupedByValueType.every((x) =>
                    selectedValueTypes.includes(x[0].valueType),
                  )}
                  onChange={toggleValueTypes}
                />
              ) : (
                <div css={{ fontWeight: 'bold' }}>{label}</div>
              )}
              <div css={{ display: 'flex', flexDirection: 'column', gap: 12, paddingLeft: 24 }}>
                {entryValuesGroupedByValueType
                  .sort((a, b) => alphabeticalSort(a[0].valueTypeLabel, b[0].valueTypeLabel))
                  .map((x) => {
                    return (
                      <Checkbox
                        key={x[0].valueType}
                        size="md"
                        label={x[0].valueTypeLabel}
                        value={[x[0].valueType]}
                        checked={selectedValueTypes.includes(x[0].valueType)}
                        onChange={toggleValueTypes}
                      />
                    )
                  })}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
